module.exports = __webpack_public_path__ + "static/img/1.69f7a35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/1.png
// module id = G7DO
// module chunks = 0